"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _BreadcrumbHelper = _interopRequireDefault(require("../../../../util/BreadcrumbHelper"));

var _index = require("../../../../index");

var _KycProcessModel = _interopRequireDefault(require("../../models/KycProcessModel"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var KYCRequests = /*#__PURE__*/function (_Component) {
  _inherits(KYCRequests, _Component);

  function KYCRequests() {
    var _this;

    _classCallCheck(this, KYCRequests);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KYCRequests).call(this));

    _BreadcrumbHelper["default"].setCrumbs([{
      label: 'KYC',
      link: '/kyc'
    }, {
      label: 'KYC Requests'
    }]);

    return _this;
  }

  _createClass(KYCRequests, [{
    key: "_renderStatus",
    value: function _renderStatus(item) {
      switch (item.status) {
        case 'approved':
          return _react["default"].createElement(_index.AppBadge, {
            text: "Approved",
            icon: "check"
          });

        case 'declined':
          return _react["default"].createElement(_index.AppBadge, {
            text: "Rejected",
            icon: "time"
          });

        case 'document_review_in_progress':
          return _react["default"].createElement(_index.AppBadge, {
            text: "Document review in progress",
            icon: "clock-o",
            type: "info"
          });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement("div", {
        className: "element-with-blur",
        style: {
          paddingTop: '2px'
        }
      }, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-users"
      }), " KYC Requests"), _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-users"
      }), " Requests"), _react["default"].createElement("div", {
        className: "header-actions"
      })), _react["default"].createElement("div", {
        className: "box-body"
      }, _react["default"].createElement(_index.AppTable, {
        filter: [{
          type: 'term'
        }],
        model: _KycProcessModel["default"],
        renderCell: function renderCell(column, item) {
          switch (column.name) {
            case 'status':
              return _this2._renderStatus(item);
          }
        },
        getColumnActions: function getColumnActions(item, index) {
          return _react["default"].createElement("div", null, _react["default"].createElement(_reactRouterDom.Link, {
            to: "/kyc/details/".concat(item.id),
            className: "button-info"
          }, "Details"));
        }
      }), _react["default"].createElement("div", {
        className: "clear"
      })));
    }
  }]);

  return KYCRequests;
}(_react.Component);

exports["default"] = KYCRequests;